import { COMMANDERS, Player } from './store.d'
import { GameSceneStoreStype } from './../../a.scenes/GameScene/store'

export const SEL_MANA_LEVEL_FOR_PLAYER = (s: GameSceneStoreStype) => {
  return s.levels.data.manaLevelsByPlayer[COMMANDERS.PLAYER]
  // s.levels.data.players.find(p => p.id === COMMANDERS.PLAYER)!
}
export const SEL_SPELLS_BY_PLAYER = (player: COMMANDERS) => (s: GameSceneStoreStype) => {
  const playerData = s.levels.data.players.find(p => p.id === player)
  return playerData && playerData.activeSpells
}
export const SEL_NEXT_SPELLS_BY_PLAYER = (player: COMMANDERS) => (s: GameSceneStoreStype) => {
  const playerData = s.levels.data.players.find(p => p.id === player)
  return playerData && playerData.spells[0]
}
export const SEL_SELECTED_SPELL = (s: GameSceneStoreStype) => {
  const player = s.levels.data.players.find((p: Player) => p.id === COMMANDERS.PLAYER) as Player
  const selectedIdx = s.levels.data.selectedSpellIdx

  return selectedIdx !== undefined && player?.activeSpells[selectedIdx]
}
export const SEL_SET_SELECTED_SPELL = (s: GameSceneStoreStype) => s.levels.setSelectedSpellIdx
export const SEL_CLEAR_SELECTED_SPELL = (s: GameSceneStoreStype) => s.levels.clearSelectedSpellIdx
export const SEL_FLAG_SPELL_CASTED = (s: GameSceneStoreStype) => s.levels.setCastedSpell
export const SEL_BATTLE_STATE = (s: GameSceneStoreStype) => s.levels.data.battleState
